module.exports = __webpack_public_path__ + "img/daily-work.87032971.png";